import { GET_LIST } from '../dataFetchActions';

export const CRUD_CHANGE_LIST_PARAMS = 'IMP/CRUD_CHANGE_LIST_PARAMS';

export const changeListParams = (resource, location, id = 'default', params) => ({
  type: CRUD_CHANGE_LIST_PARAMS,
  payload: params,
  meta: {
    resource,
    location,
    type: GET_LIST,
    //fetch: GET_LIST,
    id,
  },
});

export const SET_LIST_SELECTED_IDS = 'IMP/SET_LIST_SELECTED_IDS';
export const setListSelectedIds = (resource, location, ids = []) => ({
  type: SET_LIST_SELECTED_IDS,
  payoad: ids,
  meta: {
    resource,
    location,
  },
});

export const TOGGLE_LIST_ITEM = 'IMP/TOGGLE_LIST_ITEM';
export const toggleListItem = (resource, location, id) => ({
  type: TOGGLE_LIST_ITEM,
  payoad: id,
  meta: {
    resource,
    location,
  },
});
